import * as yup from 'yup';

export const confirmCodeSchema = yup.object().shape({
  confirmationCode: yup
    .string()
    .required()
    .length(6)
    .matches(/[0-9]+/, 'must use only digits'),
});
